import * as React from 'react';
import { connect } from 'react-redux';

import { BasePopupProps } from '../../typings/common';
import { State } from '../../typings/state';

export interface GridPopupHOCStateProps {
    isGridScrolling: boolean;
}

export interface GridPopupHOCOwnProps {
    onPopupOpen?: () => void;
}

export type GridPopupHOCProps = GridPopupHOCStateProps & GridPopupHOCOwnProps;

export interface GridPopupHOCState {
    isPopupVisible: boolean;
}

export function makeGridPopup<T>(
    PopupComponent: React.ComponentClass<T & BasePopupProps> | React.FunctionComponent<T & BasePopupProps>
): React.ComponentClass<GridPopupHOCProps & T, GridPopupHOCState> {
    return class extends React.PureComponent<GridPopupHOCProps & T, GridPopupHOCState> {
        state = {
            isPopupVisible: false
        };

        static getDerivedStateFromProps(props: GridPopupHOCProps & T, state: GridPopupHOCState) {
            if (props.isGridScrolling) {
                return {
                    ...state,
                    isPopupVisible: false
                };
            }

            return null;
        }

        render() {
            const { isPopupVisible } = this.state;
            const { onPopupOpen, isGridScrolling, ...props } = this.props;
            const popupProps = {
                switchPopupState: this.switchPopupState,
                closePopup: this.closePopup,
                openPopup: this.openPopup,
                isPopupVisible: isPopupVisible
            };

            return <PopupComponent {...(props as T)} {...popupProps} />;
        }

        private switchPopupState = (): void => {
            const isVisible = !this.state.isPopupVisible;

            if (this.props.onPopupOpen && isVisible) {
                this.props.onPopupOpen();
            }

            this.setState({
                isPopupVisible: isVisible
            });
        };

        private closePopup = () => {
            this.setState({
                isPopupVisible: false
            });
        };

        private openPopup = () => {
            this.setState({
                isPopupVisible: true
            });
        };
    };
}

const mapStateToProps = (state: State): GridPopupHOCStateProps => {
    const { isGridScrolling } = state.grid;

    return {
        isGridScrolling
    };
};

export function makeGridPopupContainer<T>(
    PopupComponent: React.ComponentClass<T & BasePopupProps> | React.FunctionComponent<T & BasePopupProps>
) {
    const GridPopup = makeGridPopup<T>(PopupComponent);

    return connect<GridPopupHOCStateProps, {}, T & GridPopupHOCOwnProps>(mapStateToProps)(GridPopup);
}
